// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/r_fallouty.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Brush-Script-Normal-Italic.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "fallouty";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "brush";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
}

:root {
  /* --primary: 120, 84%, 55%; */
  --white: 193, 100%, 90%;
  --amber: 39, 98%, 54%;
  --green: 135, 75%, 54%;
  --bluegreen: 184, 81%, 53%;
  --bg: #111;
}

#small-screen-fallback {
  display: none;
}

[theme="green"] {
  --primary: var(--green);
}
[theme="amber"] {
  --primary: var(--amber);
}
[theme="white"] {
  --primary: var(--white);
}
[theme="bluegreen"] {
  --primary: var(--bluegreen);
}

body:not([show-completed]) .completed {
  display: none !important;
}
*:not(input[type="text"]):not(textarea) {
  user-select: none;
}
::selection {
  background: hsl(var(--primary));
  color: var(--bg);
}
body {
  color-scheme: dark;
  --glow: 0 0 7px hsl(var(--primary), 0.4);
  /* --screen-glow: radial-gradient(
    circle at 85% 20%,
    hsl(var(--primary), 0.05),
    transparent 30%,
    transparent 60%,
    #000a
  ); */
  --screen-glow: radial-gradient(
    circle at center,
    hsl(var(--primary), 0.03),
    transparent 40%,
    transparent 80%,
    #0006
  );
}
.overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(to top, transparent, transparent, #0001, #0002);
  background-size: cover;
  background-size: 100% 6px;
  z-index: 100;
  overflow: clip;

  &.glow:after {
    content: "";
    display: block;
    height: 100%;
    width: 100%;
    background: var(--screen-glow);
  }
  #scanline {
    width: 100%;
    height: 100px;
    /* z-index: 8; */
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(255, 255, 255, 0.2) 10%,
      rgba(0, 0, 0, 0.1) 100%
    );
    opacity: 0.1;
    position: absolute;
    bottom: 100%;
    animation: scanline 13s linear infinite;
  }
}
body {
  color: hsl(var(--primary));
  text-shadow: var(--glow);
  border-color: hsl(var(--primary));
  font-family: fallouty;
  font-weight: 400;
  accent-color: hsl(var(--primary));
  background: var(--bg);
  overscroll-behavior: none;
  overflow: clip;
  height: 100dvh;
  width: 100dvw;
}

#app {
  display: flex;
}
h1,
h2,
h3 {
  font-weight: 500;
}
.brush {
  display: flex;
  align-items: center;
  font-family: "brush";

  .big {
    font-size: 4.5rem;
  }
  .medium {
    font-size: 3.5rem;
  }
}
.sans {
  font-family: sans-serif;
  font-weight: 600;
  font-size: 3.5rem;
  font-stretch: condensed;
}

header {
  display: flex;
  flex-direction: column;
  height: 100dvh;
  padding: 2rem 0.5rem;

  background: none;
  border-right: solid 2px;
  padding: 2rem 0;

  #logo {
    font-size: 2.5rem;
    position: relative;
    padding-inline: 2rem;
    padding-bottom: 2rem;
    height: 120px;

    .brush {
      rotate: -15deg;
      translate: 0 -1rem;
    }
    .sans {
      position: absolute;
      left: 45%;
      top: 25%;
    }
  }
}

nav {
  min-height: 0;
  flex-grow: 1;
  display: flex;

  ul {
    list-style: none;
    padding: 0;

    button {
      padding-inline: 2.5rem;
      width: 100%;
      text-align: start;
    }
  }
  & > ul {
    display: grid;
    grid-template-rows: 1fr min-content;
    max-height: 100%;
    width: 100%;
    gap: 1rem;

    .nav-top {
      min-height: 0;
      display: grid;
      grid-template-rows: min-content min-content minmax(0, 1fr);
    }
  }

  & li:not(.nav-section):not(#new-task):not(#new-project-btn) {
    position: relative;
    padding-block: 0.2rem;

    &:hover:before,
    &:focus:before,
    &.active:before {
      content: "\\25B2";
      position: absolute;
      rotate: 90deg;
      top: 17%;
      left: 0.7rem;
    }
  }
  & #projects {
    display: grid;
    grid-template-rows: min-content minmax(0, min-content) 1fr;

    ul {
      overflow-x: auto;
      margin-bottom: 0.5rem;

      .delete-project-dialog {
        padding-right: 2rem;
      }
      div {
        display: flex;

        &:hover .delete-project-dialog {
          visibility: visible;
        }
      }

      & .project-btn {
        padding-right: 0.5rem;
        &::before {
          content: "#";
          font-style: italic;
        }
      }
    }
  }

  & #settings button::before {
    content: "✱";
  }

  li.active {
    background: hsl(var(--primary));
    box-shadow: var(--glow);
    border-radius: 0;

    &:before {
      content: "";
    }

    button {
      color: var(--bg);
    }
  }
  button {
    border: none;
    display: flex;
    gap: 0.7rem;
    align-items: center;
  }

  & #new-task-btn::before,
  & #today-btn::before,
  & #credits-btn::before {
    border: solid 1.5px;
    height: 1rem;
    width: 1rem;
    line-height: 1.1rem;
    text-align: center;
    padding-left: 1px;
  }
  & #new-task-btn::before {
    content: "+";
    border-radius: 100%;
    font-size: 0.9rem;
  }
  & #credits-btn::before {
    content: "i";
    border-radius: 100%;
    font-size: 0.8rem;
    font-family: sans;
    font-weight: 900;
    line-height: 0.8rem;
  }
  & #today-btn::before {
    content: "13" !important;
    border-top-width: 4px;
    font-size: 0.6rem;
    font-style: normal !important;
    display: flex;
    align-items: anchor-center;
    justify-content: center;
  }
  & #new-project {
    display: flex;
    justify-content: center;
    position: relative;
    padding: 0;
    inset: 0;

    & #new-project-btn {
      display: flex;
      border-radius: 100%;
      font-size: 1.1rem;
      border: solid 1.5px;
      width: 1.5rem;
      padding: 0;
      height: 1.5rem;
      justify-content: center;
      padding-top: 4px;
      padding-left: 0.5px;
    }
  }
}

.h-container {
  display: flex;
  justify-content: center;
  position: relative;
  padding-block: 0.5rem;

  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0.5rem;
    width: calc(100% - 1rem);
    height: 1px;
    background: hsl(var(--primary));
    box-shadow: var(--glow);
    z-index: -1;
  }
  h2 {
    padding-inline: 0.5rem;
    font-size: 1.2rem;
    background: var(--bg);
  }
}

button {
  width: fit-content;
  padding: 0.25rem 1rem;
  cursor: pointer;
  background: none;
  color: hsl(var(--primary));
  text-shadow: var(--glow);
  border: solid 1.5px hsl(var(--primary));
  border-radius: 0;
}

.delete-project-dialog,
.delete-task-btn {
  visibility: hidden;
  font-family: Arial;
  font-size: 0.8rem;
  line-height: 0;
  width: 1rem;
  padding-inline: 0;
  border: none;
  min-height: 2rem;
  justify-content: center;
}

dialog,
input,
textarea,
select {
  border: solid 1.5px hsl(var(--primary));
  color: hsl(var(--primary));
  text-shadow: var(--glow);
  background: var(--bg);
  caret-shape: block;
  caret-animation: manual;
}

.label-container {
  display: flex;
  justify-content: space-between;
}

[invalid] input:invalid {
  outline-width: 2px;
  outline-style: solid;
  outline-offset: 2px;
  animation: flashing-outline 1s 3;
}

::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

select {
  &::picker(select) {
    border-radius: 0;
  }
  option {
    font-family: fallouty, Arial;
  }
}
.required label:after {
  content: "*";
}
select {
  min-height: 1.79rem; /* chrome */
}
textarea {
  resize: none;
}
option {
  background: var(--bg);
}

option:hover,
option:focus {
  background: hsl(var(--primary));
  color: var(--primary);
}

button,
input,
textarea,
select {
  &:focus-visible {
    outline-color: hsl(var(--primary));
    outline: solid 2px hsl(var(--primary));
    outline-offset: 2px;
    outline-style: dotted;
  }
}

input,
textarea,
select {
  padding-inline: 1rem;
}
[type="radio"],
[type="checkbox"] {
  appearance: none;
  width: 0.8rem;
  height: 0.8rem;
  border: solid 1.5px hsl(var(--primary));
  position: relative;
  padding: 0;
  box-shadow: var(--glow);
  cursor: pointer;

  &:checked::after {
    content: "";
    position: absolute;
    height: 6px;
    width: 6px;
    background: hsl(var(--primary));
    top: 2px;
    left: 2px;
  }
}

.checkbox {
  flex-direction: row-reverse;
  gap: 0.5rem;
  align-items: baseline;
  justify-content: flex-end;
  &:first-of-type {
    padding-top: 1rem;
  }
}
fieldset {
  border-color: hsl(var(--primary));
  display: flex;
  flex-direction: column;
  align-items: start;

  &.radio > div {
    flex-direction: row-reverse;
    gap: 0.5rem;
  }

  &#priority {
    flex-direction: row;
    justify-content: space-between;
  }

  div {
    display: flex;
    gap: 1rem;
    align-items: baseline;
  }
}

form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  padding: 1rem;

  & > div {
    display: flex;
    flex-direction: column;
  }
}
dialog {
  position: absolute;
  min-width: min(80dvw, 400px);
  padding: 0;
  overflow-x: hidden;
  box-shadow:
    var(--glow),
    7px 7px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: solid 1.5px;
    background: repeating-linear-gradient(
      transparent,
      transparent 4px,
      hsl(var(--primary)) 4px,
      hsl(var(--primary)) 5px
    );
    cursor: move;
  }

  h2,
  h3 {
    padding-inline: 1rem;
    border-right: solid 1.5px;
    background: var(--bg);
  }

  .close-btn {
    position: relative;
    width: 2rem;
    height: 1.8rem;
    overflow: clip;
    padding: 0;
    color: transparent;
    text-shadow: none;
    border: none;
    background: var(--bg);
    border-left: solid 1.5px hsl(var(--primary));

    &:before {
      content: "X";
      position: absolute;
      width: 100%;
      color: hsl(var(--primary));
      text-shadow: var(--glow);
      font-family: monospace;
      font-weight: bold;
      line-height: 1.5rem;
    }
  }

  .task-details {
    padding: 2rem;

    .description {
      padding-bottom: 1rem;
    }
    & > div {
      display: flex;
      gap: 1rem;

      &:has(.notes-content) {
        flex-direction: column;
        gap: 0;
      }
    }
  }
}

#dialog-backdrop {
  backdrop-filter: brightness(50%);
  position: fixed;
  inset: 0;
}

main {
  flex-grow: 1;
  height: 100dvh;
  display: grid;
  grid-template-rows: min-content minmax(0, 1fr);

  #main-header {
    position: relative;
    display: flex;
    justify-content: center;
    padding-block: 0.5rem;
    background: hsl(var(--primary));
    color: var(--bg);

    button {
      position: absolute;
      right: 2rem;
      color: var(--gb);
      border-color: var(--gb);
      width: 120px;
      text-align: center;
    }
  }
  .main-content {
    display: grid;
    grid-template-rows: repeat(2, minmax(0, min-content));
  }
  section {
    position: relative;

    &#upcoming {
      display: grid;
      grid-template-rows: min-content minmax(0, 1fr);
    }

    .msg {
      text-align: center;
      padding-block: 2rem 1rem;
    }
  }
}

.task-list-container {
  display: flex;
  justify-content: center;
  padding-inline: 2rem;
  max-height: 100%;
  overflow-y: auto;

  ul {
    list-style: none;
    padding: 1rem 0 2rem 0;
    overflow: clip;
  }

  .toggle-complete {
    margin-top: 0.45rem;
  }

  .btn-container {
    padding-top: 0.6rem;
  }

  & li:hover {
    .delete-task-btn {
      visibility: visible;
    }
  }

  .task {
    width: 360px;
    display: flex;
    position: relative;
    gap: 2rem;
    padding-block: 1rem;
    margin-right: 2rem;
    border-bottom: solid 1px;

    .task-details-btn {
      border: none;
      padding: 0;
    }
    .delete-task-btn {
      position: absolute;
      right: -1.5rem;
    }
    h3 {
      text-align: start;
      font-size: 1.2rem;
    }
  }

  & li:last-child .task {
    border-bottom: none;
  }

  .task-body {
    flex-grow: 1;
  }
  .details {
    position: relative;
    display: flex;
    justify-content: space-between;
    line-height: 1.1;
  }

  .priority {
    min-width: 20px;
    text-align: center;
  }
  .overdue,
  .critical,
  .high {
    background: hsl(var(--primary));
    color: var(--bg);
    padding-inline: 0.25rem;
  }

  .low > span {
    font-size: 0.7rem;
  }

  .completed {
    padding-block: 0.2rem;

    .btn-container {
      display: none;
    }

    .title {
      text-decoration: line-through;
      text-decoration-thickness: 2px;
      text-decoration-inset: -0.5rem;
    }
    .details {
      display: none;
    }
  }
}

#delete-quest-dialog {
  .content {
    padding: 1rem;
  }
  .btn-container {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-top: 1rem;
  }
}
@keyframes scanline {
  0% {
    bottom: 100%;
  }
  90% {
    bottom: 100%;
  }
  100% {
    bottom: -20%;
  }
}

dialog#credits-dialog {
  padding: 1rem;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 2rem;
  }

  h1 {
    display: flex;
    font-size: 2.5rem;
    justify-content: center;
    padding-bottom: 1rem;

    .sans {
      margin-top: 0.5rem;
    }
  }

  h2 {
    padding: 0;
    border: none;
  }

  a {
    color: inherit;
  }

  #author {
    align-self: end;
  }
}

.tooltip-container {
  position: relative;
}
[role="tooltip"] {
  visibility: hidden;
  position: absolute;
  top: 1.2rem;
  left: 1.2rem;
  background: var(--bg);
  color: hsl(var(--primary));
  padding: 0.5rem;
  border: solid 1.5px hsl(var(--primary));
}
[aria-describedby]:hover + [role="tooltip"],
[aria-describedby]:focus + [role="tooltip"] {
  visibility: visible;
  z-index: 100;
  transition: visibility 0s 0.5s;
  width: max-content;
}

#render-jank {
  position: absolute;
  inset: 0;
  background: var(--bg);
  top: 100%;
  z-index: 100;
  /* border-top: solid 2px hsl(var(--primary), 0.2); */
}

@keyframes flashing-outline {
  from {
    outline-color: transparent;
  }

  to {
    outline-color: hsl(var(--primary));
  }
}
@media (width < 40rem) {
  #app {
    display: none;
  }
  #small-screen-fallback {
    display: flex !important;
    height: 100%;
    justify-content: center;
    padding-block: 5rem;
    padding-inline: 1rem;

    & > div {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    h1 {
      font-family: brush;
      font-size: 3rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,2DAA0D;AAC5D;;AAEA;EACE,oBAAoB;EACpB,4DAA4E;AAC9E;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,wCAAwC;EACxC;;;;;;MAMI;EACJ;;;;;;GAMC;AACH;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,2EAA2E;EAC3E,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,cAAc;;EAEd;IACE,WAAW;IACX,cAAc;IACd,YAAY;IACZ,WAAW;IACX,8BAA8B;EAChC;EACA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB;;;;;KAKC;IACD,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,uCAAuC;EACzC;AACF;AACA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;;EAEpB;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,oBAAoB;;EAEpB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;;EAEf;IACE,iBAAiB;IACjB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;;IAEb;MACE,cAAc;MACd,kBAAkB;IACpB;IACA;MACE,kBAAkB;MAClB,SAAS;MACT,QAAQ;IACV;EACF;AACF;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;;EAEb;IACE,gBAAgB;IAChB,UAAU;;IAEV;MACE,sBAAsB;MACtB,WAAW;MACX,iBAAiB;IACnB;EACF;EACA;IACE,aAAa;IACb,mCAAmC;IACnC,gBAAgB;IAChB,WAAW;IACX,SAAS;;IAET;MACE,aAAa;MACb,aAAa;MACb,0DAA0D;IAC5D;EACF;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;;IAErB;;;MAGE,gBAAgB;MAChB,kBAAkB;MAClB,aAAa;MACb,QAAQ;MACR,YAAY;IACd;EACF;EACA;IACE,aAAa;IACb,0DAA0D;;IAE1D;MACE,gBAAgB;MAChB,qBAAqB;;MAErB;QACE,mBAAmB;MACrB;MACA;QACE,aAAa;;QAEb;UACE,mBAAmB;QACrB;MACF;;MAEA;QACE,qBAAqB;QACrB;UACE,YAAY;UACZ,kBAAkB;QACpB;MACF;IACF;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,+BAA+B;IAC/B,uBAAuB;IACvB,gBAAgB;;IAEhB;MACE,WAAW;IACb;;IAEA;MACE,gBAAgB;IAClB;EACF;EACA;IACE,YAAY;IACZ,aAAa;IACb,WAAW;IACX,mBAAmB;EACrB;;EAEA;;;IAGE,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,wBAAwB;IACxB,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,QAAQ;;IAER;MACE,aAAa;MACb,mBAAmB;MACnB,iBAAiB;MACjB,mBAAmB;MACnB,aAAa;MACb,UAAU;MACV,cAAc;MACd,uBAAuB;MACvB,gBAAgB;MAChB,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;;EAErB;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,wBAAwB;IACxB,WAAW;IACX,+BAA+B;IAC/B,uBAAuB;IACvB,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;EACxB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;;;EAIE,uCAAuC;EACvC,0BAA0B;EAC1B,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,YAAY;AACd;AACA;EACE,mBAAmB,EAAE,WAAW;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;;;EAIE;IACE,kCAAkC;IAClC,sCAAsC;IACtC,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;;;EAGE,oBAAoB;AACtB;AACA;;EAEE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,eAAe;;EAEf;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,+BAA+B;IAC/B,QAAQ;IACR,SAAS;EACX;AACF;;AAEA;EACE,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB;IACE,iBAAiB;EACnB;AACF;AACA;EACE,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,kBAAkB;;EAElB;IACE,2BAA2B;IAC3B,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,SAAS;IACT,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,aAAa;;EAEb;IACE,aAAa;IACb,sBAAsB;EACxB;AACF;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;EACV,kBAAkB;EAClB;;WAES;;EAET;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;IAC1B;;;;;KAKC;IACD,YAAY;EACd;;EAEA;;IAEE,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,qBAAqB;IACrB,4CAA4C;;IAE5C;MACE,YAAY;MACZ,kBAAkB;MAClB,WAAW;MACX,0BAA0B;MAC1B,wBAAwB;MACxB,sBAAsB;MACtB,iBAAiB;MACjB,mBAAmB;IACrB;EACF;;EAEA;IACE,aAAa;;IAEb;MACE,oBAAoB;IACtB;IACA;MACE,aAAa;MACb,SAAS;;MAET;QACE,sBAAsB;QACtB,MAAM;MACR;IACF;EACF;AACF;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8CAA8C;;EAE9C;IACE,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,+BAA+B;IAC/B,gBAAgB;;IAEhB;MACE,kBAAkB;MAClB,WAAW;MACX,gBAAgB;MAChB,uBAAuB;MACvB,YAAY;MACZ,kBAAkB;IACpB;EACF;EACA;IACE,aAAa;IACb,qDAAqD;EACvD;EACA;IACE,kBAAkB;;IAElB;MACE,aAAa;MACb,8CAA8C;IAChD;;IAEA;MACE,kBAAkB;MAClB,wBAAwB;IAC1B;EACF;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;;EAEhB;IACE,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;;IAExB;MACE,YAAY;MACZ,UAAU;IACZ;IACA;MACE,kBAAkB;MAClB,cAAc;IAChB;IACA;MACE,iBAAiB;MACjB,iBAAiB;IACnB;EACF;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;EACA;;;IAGE,+BAA+B;IAC/B,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;;IAErB;MACE,aAAa;IACf;;IAEA;MACE,6BAA6B;MAC7B,8BAA8B;MAC9B,8BAA8B;IAChC;IACA;MACE,aAAa;IACf;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,iBAAiB;EACnB;AACF;AACA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,aAAa;;EAEb;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;;IAEpB;MACE,kBAAkB;IACpB;EACF;;EAEA;IACE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,uCAAuC;AACzC;AACA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,SAAS;EACT,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;EACpC;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,wBAAwB;IACxB,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;;IAEpB;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;IACA;MACE,kBAAkB;MAClB,eAAe;IACjB;EACF;AACF","sourcesContent":["@font-face {\n  font-family: \"fallouty\";\n  src: url(\"../assets/fonts/r_fallouty.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"brush\";\n  src: url(\"../assets/fonts/Brush-Script-Normal-Italic.woff2\") format(\"woff2\");\n}\n\n:root {\n  /* --primary: 120, 84%, 55%; */\n  --white: 193, 100%, 90%;\n  --amber: 39, 98%, 54%;\n  --green: 135, 75%, 54%;\n  --bluegreen: 184, 81%, 53%;\n  --bg: #111;\n}\n\n#small-screen-fallback {\n  display: none;\n}\n\n[theme=\"green\"] {\n  --primary: var(--green);\n}\n[theme=\"amber\"] {\n  --primary: var(--amber);\n}\n[theme=\"white\"] {\n  --primary: var(--white);\n}\n[theme=\"bluegreen\"] {\n  --primary: var(--bluegreen);\n}\n\nbody:not([show-completed]) .completed {\n  display: none !important;\n}\n*:not(input[type=\"text\"]):not(textarea) {\n  user-select: none;\n}\n::selection {\n  background: hsl(var(--primary));\n  color: var(--bg);\n}\nbody {\n  color-scheme: dark;\n  --glow: 0 0 7px hsl(var(--primary), 0.4);\n  /* --screen-glow: radial-gradient(\n    circle at 85% 20%,\n    hsl(var(--primary), 0.05),\n    transparent 30%,\n    transparent 60%,\n    #000a\n  ); */\n  --screen-glow: radial-gradient(\n    circle at center,\n    hsl(var(--primary), 0.03),\n    transparent 40%,\n    transparent 80%,\n    #0006\n  );\n}\n.overlay {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  background: linear-gradient(to top, transparent, transparent, #0001, #0002);\n  background-size: cover;\n  background-size: 100% 6px;\n  z-index: 100;\n  overflow: clip;\n\n  &.glow:after {\n    content: \"\";\n    display: block;\n    height: 100%;\n    width: 100%;\n    background: var(--screen-glow);\n  }\n  #scanline {\n    width: 100%;\n    height: 100px;\n    /* z-index: 8; */\n    background: linear-gradient(\n      0deg,\n      rgba(0, 0, 0, 0) 0%,\n      rgba(255, 255, 255, 0.2) 10%,\n      rgba(0, 0, 0, 0.1) 100%\n    );\n    opacity: 0.1;\n    position: absolute;\n    bottom: 100%;\n    animation: scanline 13s linear infinite;\n  }\n}\nbody {\n  color: hsl(var(--primary));\n  text-shadow: var(--glow);\n  border-color: hsl(var(--primary));\n  font-family: fallouty;\n  font-weight: 400;\n  accent-color: hsl(var(--primary));\n  background: var(--bg);\n  overscroll-behavior: none;\n  overflow: clip;\n  height: 100dvh;\n  width: 100dvw;\n}\n\n#app {\n  display: flex;\n}\nh1,\nh2,\nh3 {\n  font-weight: 500;\n}\n.brush {\n  display: flex;\n  align-items: center;\n  font-family: \"brush\";\n\n  .big {\n    font-size: 4.5rem;\n  }\n  .medium {\n    font-size: 3.5rem;\n  }\n}\n.sans {\n  font-family: sans-serif;\n  font-weight: 600;\n  font-size: 3.5rem;\n  font-stretch: condensed;\n}\n\nheader {\n  display: flex;\n  flex-direction: column;\n  height: 100dvh;\n  padding: 2rem 0.5rem;\n\n  background: none;\n  border-right: solid 2px;\n  padding: 2rem 0;\n\n  #logo {\n    font-size: 2.5rem;\n    position: relative;\n    padding-inline: 2rem;\n    padding-bottom: 2rem;\n    height: 120px;\n\n    .brush {\n      rotate: -15deg;\n      translate: 0 -1rem;\n    }\n    .sans {\n      position: absolute;\n      left: 45%;\n      top: 25%;\n    }\n  }\n}\n\nnav {\n  min-height: 0;\n  flex-grow: 1;\n  display: flex;\n\n  ul {\n    list-style: none;\n    padding: 0;\n\n    button {\n      padding-inline: 2.5rem;\n      width: 100%;\n      text-align: start;\n    }\n  }\n  & > ul {\n    display: grid;\n    grid-template-rows: 1fr min-content;\n    max-height: 100%;\n    width: 100%;\n    gap: 1rem;\n\n    .nav-top {\n      min-height: 0;\n      display: grid;\n      grid-template-rows: min-content min-content minmax(0, 1fr);\n    }\n  }\n\n  & li:not(.nav-section):not(#new-task):not(#new-project-btn) {\n    position: relative;\n    padding-block: 0.2rem;\n\n    &:hover:before,\n    &:focus:before,\n    &.active:before {\n      content: \"\\25B2\";\n      position: absolute;\n      rotate: 90deg;\n      top: 17%;\n      left: 0.7rem;\n    }\n  }\n  & #projects {\n    display: grid;\n    grid-template-rows: min-content minmax(0, min-content) 1fr;\n\n    ul {\n      overflow-x: auto;\n      margin-bottom: 0.5rem;\n\n      .delete-project-dialog {\n        padding-right: 2rem;\n      }\n      div {\n        display: flex;\n\n        &:hover .delete-project-dialog {\n          visibility: visible;\n        }\n      }\n\n      & .project-btn {\n        padding-right: 0.5rem;\n        &::before {\n          content: \"#\";\n          font-style: italic;\n        }\n      }\n    }\n  }\n\n  & #settings button::before {\n    content: \"✱\";\n  }\n\n  li.active {\n    background: hsl(var(--primary));\n    box-shadow: var(--glow);\n    border-radius: 0;\n\n    &:before {\n      content: \"\";\n    }\n\n    button {\n      color: var(--bg);\n    }\n  }\n  button {\n    border: none;\n    display: flex;\n    gap: 0.7rem;\n    align-items: center;\n  }\n\n  & #new-task-btn::before,\n  & #today-btn::before,\n  & #credits-btn::before {\n    border: solid 1.5px;\n    height: 1rem;\n    width: 1rem;\n    line-height: 1.1rem;\n    text-align: center;\n    padding-left: 1px;\n  }\n  & #new-task-btn::before {\n    content: \"+\";\n    border-radius: 100%;\n    font-size: 0.9rem;\n  }\n  & #credits-btn::before {\n    content: \"i\";\n    border-radius: 100%;\n    font-size: 0.8rem;\n    font-family: sans;\n    font-weight: 900;\n    line-height: 0.8rem;\n  }\n  & #today-btn::before {\n    content: \"13\" !important;\n    border-top-width: 4px;\n    font-size: 0.6rem;\n    font-style: normal !important;\n    display: flex;\n    align-items: anchor-center;\n    justify-content: center;\n  }\n  & #new-project {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    padding: 0;\n    inset: 0;\n\n    & #new-project-btn {\n      display: flex;\n      border-radius: 100%;\n      font-size: 1.1rem;\n      border: solid 1.5px;\n      width: 1.5rem;\n      padding: 0;\n      height: 1.5rem;\n      justify-content: center;\n      padding-top: 4px;\n      padding-left: 0.5px;\n    }\n  }\n}\n\n.h-container {\n  display: flex;\n  justify-content: center;\n  position: relative;\n  padding-block: 0.5rem;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 0.5rem;\n    width: calc(100% - 1rem);\n    height: 1px;\n    background: hsl(var(--primary));\n    box-shadow: var(--glow);\n    z-index: -1;\n  }\n  h2 {\n    padding-inline: 0.5rem;\n    font-size: 1.2rem;\n    background: var(--bg);\n  }\n}\n\nbutton {\n  width: fit-content;\n  padding: 0.25rem 1rem;\n  cursor: pointer;\n  background: none;\n  color: hsl(var(--primary));\n  text-shadow: var(--glow);\n  border: solid 1.5px hsl(var(--primary));\n  border-radius: 0;\n}\n\n.delete-project-dialog,\n.delete-task-btn {\n  visibility: hidden;\n  font-family: Arial;\n  font-size: 0.8rem;\n  line-height: 0;\n  width: 1rem;\n  padding-inline: 0;\n  border: none;\n  min-height: 2rem;\n  justify-content: center;\n}\n\ndialog,\ninput,\ntextarea,\nselect {\n  border: solid 1.5px hsl(var(--primary));\n  color: hsl(var(--primary));\n  text-shadow: var(--glow);\n  background: var(--bg);\n  caret-shape: block;\n  caret-animation: manual;\n}\n\n.label-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n[invalid] input:invalid {\n  outline-width: 2px;\n  outline-style: solid;\n  outline-offset: 2px;\n  animation: flashing-outline 1s 3;\n}\n\n::-webkit-calendar-picker-indicator {\n  filter: invert(1);\n}\n\nselect {\n  &::picker(select) {\n    border-radius: 0;\n  }\n  option {\n    font-family: fallouty, Arial;\n  }\n}\n.required label:after {\n  content: \"*\";\n}\nselect {\n  min-height: 1.79rem; /* chrome */\n}\ntextarea {\n  resize: none;\n}\noption {\n  background: var(--bg);\n}\n\noption:hover,\noption:focus {\n  background: hsl(var(--primary));\n  color: var(--primary);\n}\n\nbutton,\ninput,\ntextarea,\nselect {\n  &:focus-visible {\n    outline-color: hsl(var(--primary));\n    outline: solid 2px hsl(var(--primary));\n    outline-offset: 2px;\n    outline-style: dotted;\n  }\n}\n\ninput,\ntextarea,\nselect {\n  padding-inline: 1rem;\n}\n[type=\"radio\"],\n[type=\"checkbox\"] {\n  appearance: none;\n  width: 0.8rem;\n  height: 0.8rem;\n  border: solid 1.5px hsl(var(--primary));\n  position: relative;\n  padding: 0;\n  box-shadow: var(--glow);\n  cursor: pointer;\n\n  &:checked::after {\n    content: \"\";\n    position: absolute;\n    height: 6px;\n    width: 6px;\n    background: hsl(var(--primary));\n    top: 2px;\n    left: 2px;\n  }\n}\n\n.checkbox {\n  flex-direction: row-reverse;\n  gap: 0.5rem;\n  align-items: baseline;\n  justify-content: flex-end;\n  &:first-of-type {\n    padding-top: 1rem;\n  }\n}\nfieldset {\n  border-color: hsl(var(--primary));\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n\n  &.radio > div {\n    flex-direction: row-reverse;\n    gap: 0.5rem;\n  }\n\n  &#priority {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  div {\n    display: flex;\n    gap: 1rem;\n    align-items: baseline;\n  }\n}\n\nform {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  width: 100%;\n  padding: 1rem;\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n  }\n}\ndialog {\n  position: absolute;\n  min-width: min(80dvw, 400px);\n  padding: 0;\n  overflow-x: hidden;\n  box-shadow:\n    var(--glow),\n    7px 7px;\n\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: solid 1.5px;\n    background: repeating-linear-gradient(\n      transparent,\n      transparent 4px,\n      hsl(var(--primary)) 4px,\n      hsl(var(--primary)) 5px\n    );\n    cursor: move;\n  }\n\n  h2,\n  h3 {\n    padding-inline: 1rem;\n    border-right: solid 1.5px;\n    background: var(--bg);\n  }\n\n  .close-btn {\n    position: relative;\n    width: 2rem;\n    height: 1.8rem;\n    overflow: clip;\n    padding: 0;\n    color: transparent;\n    text-shadow: none;\n    border: none;\n    background: var(--bg);\n    border-left: solid 1.5px hsl(var(--primary));\n\n    &:before {\n      content: \"X\";\n      position: absolute;\n      width: 100%;\n      color: hsl(var(--primary));\n      text-shadow: var(--glow);\n      font-family: monospace;\n      font-weight: bold;\n      line-height: 1.5rem;\n    }\n  }\n\n  .task-details {\n    padding: 2rem;\n\n    .description {\n      padding-bottom: 1rem;\n    }\n    & > div {\n      display: flex;\n      gap: 1rem;\n\n      &:has(.notes-content) {\n        flex-direction: column;\n        gap: 0;\n      }\n    }\n  }\n}\n\n#dialog-backdrop {\n  backdrop-filter: brightness(50%);\n  position: fixed;\n  inset: 0;\n}\n\nmain {\n  flex-grow: 1;\n  height: 100dvh;\n  display: grid;\n  grid-template-rows: min-content minmax(0, 1fr);\n\n  #main-header {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    padding-block: 0.5rem;\n    background: hsl(var(--primary));\n    color: var(--bg);\n\n    button {\n      position: absolute;\n      right: 2rem;\n      color: var(--gb);\n      border-color: var(--gb);\n      width: 120px;\n      text-align: center;\n    }\n  }\n  .main-content {\n    display: grid;\n    grid-template-rows: repeat(2, minmax(0, min-content));\n  }\n  section {\n    position: relative;\n\n    &#upcoming {\n      display: grid;\n      grid-template-rows: min-content minmax(0, 1fr);\n    }\n\n    .msg {\n      text-align: center;\n      padding-block: 2rem 1rem;\n    }\n  }\n}\n\n.task-list-container {\n  display: flex;\n  justify-content: center;\n  padding-inline: 2rem;\n  max-height: 100%;\n  overflow-y: auto;\n\n  ul {\n    list-style: none;\n    padding: 1rem 0 2rem 0;\n    overflow: clip;\n  }\n\n  .toggle-complete {\n    margin-top: 0.45rem;\n  }\n\n  .btn-container {\n    padding-top: 0.6rem;\n  }\n\n  & li:hover {\n    .delete-task-btn {\n      visibility: visible;\n    }\n  }\n\n  .task {\n    width: 360px;\n    display: flex;\n    position: relative;\n    gap: 2rem;\n    padding-block: 1rem;\n    margin-right: 2rem;\n    border-bottom: solid 1px;\n\n    .task-details-btn {\n      border: none;\n      padding: 0;\n    }\n    .delete-task-btn {\n      position: absolute;\n      right: -1.5rem;\n    }\n    h3 {\n      text-align: start;\n      font-size: 1.2rem;\n    }\n  }\n\n  & li:last-child .task {\n    border-bottom: none;\n  }\n\n  .task-body {\n    flex-grow: 1;\n  }\n  .details {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    line-height: 1.1;\n  }\n\n  .priority {\n    min-width: 20px;\n    text-align: center;\n  }\n  .overdue,\n  .critical,\n  .high {\n    background: hsl(var(--primary));\n    color: var(--bg);\n    padding-inline: 0.25rem;\n  }\n\n  .low > span {\n    font-size: 0.7rem;\n  }\n\n  .completed {\n    padding-block: 0.2rem;\n\n    .btn-container {\n      display: none;\n    }\n\n    .title {\n      text-decoration: line-through;\n      text-decoration-thickness: 2px;\n      text-decoration-inset: -0.5rem;\n    }\n    .details {\n      display: none;\n    }\n  }\n}\n\n#delete-quest-dialog {\n  .content {\n    padding: 1rem;\n  }\n  .btn-container {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    padding-top: 1rem;\n  }\n}\n@keyframes scanline {\n  0% {\n    bottom: 100%;\n  }\n  90% {\n    bottom: 100%;\n  }\n  100% {\n    bottom: -20%;\n  }\n}\n\ndialog#credits-dialog {\n  padding: 1rem;\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n  }\n\n  h1 {\n    display: flex;\n    font-size: 2.5rem;\n    justify-content: center;\n    padding-bottom: 1rem;\n\n    .sans {\n      margin-top: 0.5rem;\n    }\n  }\n\n  h2 {\n    padding: 0;\n    border: none;\n  }\n\n  a {\n    color: inherit;\n  }\n\n  #author {\n    align-self: end;\n  }\n}\n\n.tooltip-container {\n  position: relative;\n}\n[role=\"tooltip\"] {\n  visibility: hidden;\n  position: absolute;\n  top: 1.2rem;\n  left: 1.2rem;\n  background: var(--bg);\n  color: hsl(var(--primary));\n  padding: 0.5rem;\n  border: solid 1.5px hsl(var(--primary));\n}\n[aria-describedby]:hover + [role=\"tooltip\"],\n[aria-describedby]:focus + [role=\"tooltip\"] {\n  visibility: visible;\n  z-index: 100;\n  transition: visibility 0s 0.5s;\n  width: max-content;\n}\n\n#render-jank {\n  position: absolute;\n  inset: 0;\n  background: var(--bg);\n  top: 100%;\n  z-index: 100;\n  /* border-top: solid 2px hsl(var(--primary), 0.2); */\n}\n\n@keyframes flashing-outline {\n  from {\n    outline-color: transparent;\n  }\n\n  to {\n    outline-color: hsl(var(--primary));\n  }\n}\n@media (width < 40rem) {\n  #app {\n    display: none;\n  }\n  #small-screen-fallback {\n    display: flex !important;\n    height: 100%;\n    justify-content: center;\n    padding-block: 5rem;\n    padding-inline: 1rem;\n\n    & > div {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n    }\n    h1 {\n      font-family: brush;\n      font-size: 3rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
